export var SkillData = [
    {
    "title": "React Js",
    "percent": "75"
    
  },
    {
    "title": "JavaScript",
    "percent": "80"
    
  },
    {
    "title": "HTML",
    "percent": "95"
    
  }
  ,
    {
    "title": "CSS",
    "percent": "95"
    
  },
    {
    "title": "Bootstrap",
    "percent": "98"
    
  },
    {
    "title": "MongoDB",
    "percent": "70"
    
  },
    {
    "title": "Tailwind CSS",
    "percent": "85"
    
  },
  
    {
    "title": "Express Js",
    "percent": "50"
    
  },
  {
    "title": "Firebase",
    "percent": "50"
    
  },
  {
    "title": "Jquery",
    "percent": "60"
    
  }
];